<template>
  <div>
    <RouterView />
  </div>
</template>

<script lang="ts" setup>
  import '@/styles/main.scss';
  import { captureException, reportMFRendered, trackExperimentBranch } from '@experience/core-hostapp-share-lib';
  import { initHotReloader, setCssFilesLinksAttribute } from '@experience/vite-plugin-wc-extract-styles';
  import { onErrorCaptured, onMounted, useShadowRoot, nextTick } from 'vue';
  import { useRouter } from 'vue-router';
  import { DESTINATION_GUIDES_REDESIGN_EXPERIMENT_SLUG, MF_NAME, SENTRY_DSN, getMFName } from '@/shared/consts';

  const router = useRouter();

  onErrorCaptured((err) => captureException(err, { mf: MF_NAME, dsn: SENTRY_DSN, mfRelease: __APP_VERSION__ }));

  onMounted(async () => {
    // Make sure router is fully initialized
    await router.isReady();
    // Wait for the current render to complete
    await nextTick();

    await trackExperimentBranch(DESTINATION_GUIDES_REDESIGN_EXPERIMENT_SLUG, {
      mfName: MF_NAME,
      mfRelease: __APP_VERSION__,
    });

    setTimeout(() => {
      const mfName = getMFName(router.currentRoute.value.path);
      reportMFRendered(mfName);
    }, 0);
  });

  const shadowRoot = useShadowRoot();

  initHotReloader(import.meta.hot, shadowRoot);
  setCssFilesLinksAttribute(
    shadowRoot,
    import.meta.env.MODE === 'production' ? `/mfs/${MF_NAME}/` : '/',
    'data-external-style-url',
    '%%PROD_STYLESHEET_FILE_LINK%%',
    '',
  );
</script>

<style lang="scss">
  a {
    color: var(--comp-button-outline-color-text-neutral);
    text-decoration: none;
  }
</style>
